import React from "react";
import { formatInvoiceUpdatedAt } from "../../helpers/invoices";
import { resolveInvoiceDueDate } from "../../helpers/invoicePaymentTerms";
import {
  formatDaysUntilDueLabel,
  formatInvoiceCollectionStatusLabel,
  getInvoiceCollectionStatus,
  getInvoiceCollectionStatusPillStyle,
  shouldShowInvoiceDueInfo,
} from "../../helpers/invoiceDueStatus";

export function formatInvoiceDueDateDisplay(invoice) {
  const dueDate = resolveInvoiceDueDate(invoice);
  if (!dueDate) {
    return "—";
  }
  return formatInvoiceUpdatedAt(`${dueDate}T12:00:00.000Z`);
}

export function InvoiceDueStatusBadge({ invoice, asOfDate = new Date() }) {
  if (!shouldShowInvoiceDueInfo(invoice)) {
    return null;
  }

  const collectionStatus = getInvoiceCollectionStatus(invoice, asOfDate);
  if (!collectionStatus) {
    return null;
  }

  return (
    <div style={getInvoiceCollectionStatusPillStyle(collectionStatus)}>
      {formatInvoiceCollectionStatusLabel(collectionStatus, invoice, asOfDate)}
    </div>
  );
}

export function InvoiceDueDateSummary({ invoice, asOfDate = new Date() }) {
  if (!shouldShowInvoiceDueInfo(invoice)) {
    return null;
  }

  const dueLabel = formatDaysUntilDueLabel(invoice, asOfDate);
  const dueDateDisplay = formatInvoiceDueDateDisplay(invoice);

  return (
    <div style={{ opacity: 0.65, fontSize: "13px", marginTop: "6px" }}>
      <div>Due {dueDateDisplay}</div>
      {dueLabel ? (
        <div
          style={{
            marginTop: "4px",
            color:
              getInvoiceCollectionStatus(invoice, asOfDate) === "overdue"
                ? "#e06b5a"
                : undefined,
          }}
        >
          {dueLabel}
        </div>
      ) : null}
    </div>
  );
}
